import React, { useRef, useState } from 'react';
import {
  AiChatButton,
  AquistaButton,
  AquistaButtonsContainer,
  CompanyInfoElements,
  CompanyInformationContainer,
  LeftCol,
  LogoContainer,
  LogoPriceContainer,
  Price,
  PriceContainer,
  QuoteInformationContainer,
  QuoteInformationItem,
  RightCol,
  RiskCardStyles,
  SavedButton,
} from '../ResultPageComponents/v2/RiskCard.styles';
import preventiveIcon from '../../../../assets/redesign_icons/preventivo-icon.svg';
import preContractIcon from '../../../../assets/redesign_icons/pre-contract-icon.svg';
import { downloadResourceDocs } from '../../../../services/axios-client/axeCommons';
import SparklesIcon from '../../../../assets/images/icons/SparklesIcon';
import { Chat } from '../../chats/MiniChat/MiniChat';
import { BACKEND_BASE_URL } from '../../../../config';

function ProfessionRiskCard({
  quote, requestInfo, selectQuotation, professionId = null, type, profession,
}) {
  const [openChat, setOpenChat] = useState(false);
  const chatRef = useRef();

  const extraText = `Massimale: ${quote.massimale != 0 ? `Massimale: ${quote.massimale}` : ' '
  } - Copertura: ${quote.copertura}`;

  return (
    <RiskCardStyles>
      <div className="row-container">
        <LeftCol>
          <AiChatButton onClick={() => setOpenChat(true)}>
            <SparklesIcon width={24} height={24} />
            <span>Chiedi all'AI</span>
          </AiChatButton>
          <Chat
            ref={chatRef}
            openChat={openChat}
            setOpenChat={setOpenChat}
            company_id={quote.company_id}
            product_id={quote.product_id}
            quote_type={quote.quote_type}
            company_name={quote.company.name}
            extraText={extraText}
            professionId={professionId}
            sub_product={null}
          />
          <LogoPriceContainer>
            <LogoContainer>
              <img src={BACKEND_BASE_URL + quote.company.logo} alt="Profession Logo" />
            </LogoContainer>
            <PriceContainer>
              <Price>
                <h5>Prezzo annuo:</h5>
                <h2>
                  &euro;
                  {quote.amount.toFixed(2).toLocaleString()}
                </h2>
              </Price>
            </PriceContainer>
          </LogoPriceContainer>
          <CompanyInformationContainer>
            {quote.quote_type === 'tutela_legale' && quote.company_id !== 1002 && (
              <>
                <CompanyInfoElements
                  onClick={() => downloadResourceDocs(10, 0)}
                  title="questionario_pi_tutela_legale"
                >
                  <img src={preventiveIcon} alt="" />
                  <p>Questionario</p>
                </CompanyInfoElements>
                <CompanyInfoElements
                  onClick={() => downloadResourceDocs(9, 0)}
                  title="set_informativo_pi_Tutela_legale"
                >
                  <img src={preContractIcon} alt="" />
                  <p>Informativa Precontrattuale</p>
                </CompanyInfoElements>
              </>
            )}
          </CompanyInformationContainer>
          <QuoteInformationContainer>
            <QuoteInformationItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Prodotto:</h6>
              <p>{quote.company_id === 4 ? quote.product_name : type.name}</p>
            </QuoteInformationItem>
            {quote.massimale != 0 && (
              <QuoteInformationItem>
                <h6>Massimale:</h6>
                <p>
                  {quote.company_id === 4 ? quote.massimale : Number(profession.billed_maximum).toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                  })}
                  {' '}
                  &euro;
                </p>
              </QuoteInformationItem>
            )}
            <QuoteInformationItem>
              <h6>Frequenza pagamento:</h6>
              <p>Annuo</p>
            </QuoteInformationItem>
          </QuoteInformationContainer>
          <QuoteInformationContainer className="ms-3 ms-sm-0">
            {quote.copertura
              && (
                <QuoteInformationItem>
                  <h6>Copertura:</h6>
                  <p>{quote.copertura}</p>
                </QuoteInformationItem>
              )}
            {quote.deductible && quote.company_id === 1002
              && (
                <QuoteInformationItem>
                  <h6>Franchigia:</h6>
                  <p>
                    {Number(quote.deductible).toLocaleString('it-IT', {
                      minimumFractionDigits: 2,
                    })}
                    {' '}
                    &euro;
                  </p>
                </QuoteInformationItem>
              )}
            {quote.deductible_plus && quote.company_id === 1002
              && (
                <QuoteInformationItem>
                  <h6>Franchigia:</h6>
                  <p>
                    {Number(quote.deductible_plus).toLocaleString('it-IT', {
                      minimumFractionDigits: 2,
                    })}
                  </p>
                </QuoteInformationItem>
              )}
          </QuoteInformationContainer>
        </LeftCol>
        <RightCol>
          <AquistaButtonsContainer>
            <div className="mobile-width">
              {requestInfo.tutela_legale_quote_id !== quote.id ? (
                <AquistaButton
                  onClick={() => selectQuotation(quote.id)}
                  className="result-profession-sixth-step"
                >
                  Seleziona
                </AquistaButton>
              ) : (
                requestInfo.tutela_legale_quote_id === quote.id && (
                  <SavedButton>Aggiunto</SavedButton>
                )
              )}
            </div>
          </AquistaButtonsContainer>
        </RightCol>
      </div>
    </RiskCardStyles>
  );
}

export default ProfessionRiskCard;
